export const classes = {
  button: {
    width: 36,
    height: 36,
    padding: 0,
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    border: '0.5px solid rgba(255, 255, 255, 0.15)',
    transition: 'background-color 120ms ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.18)',
    },
  },
  icon: {
    width: 18,
    height: 18,
    fontSize: 18,
    color: 'rgba(255, 255, 255, 0.8)',
  },
  menuPaper: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    marginTop: '8px',
    minWidth: 160,
  },
  menuList: {
    padding: '4px 0',
  },
  menuItem: {
    padding: '7px 12px',
    fontSize: 14,
    color: '#111827',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '&.Mui-selected': {
      backgroundColor: 'rgba(0, 0, 0, 0.06)',
    },
    '&.Mui-selected:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  },
};